module.exports = __webpack_public_path__ + "static/img/2.850aa57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/dice/2.png
// module id = kXFA
// module chunks = 2